<!-- <div class="container-fluid admin-wrapper mt-4 p-3">

  <div class="admin-header-card">

    <div class="admin-title">
      <i class="fas fa-user-shield"></i>
      <span>Admin Dashboard</span>
    </div>

    <div class="d-flex gap-2">
      <button class="btn dash-btn logout" (click)="onLogout()">
        <i class="fas fa-right-from-bracket"></i>
        Logout
      </button>

    </div>

  </div>

  <div class="admin-section-card mb-4">

    <h4 class="section-title">
      <i class="fas fa-database"></i>
      Database Dump
    </h4>

    <p class="dump-sub-label">Select a database and generate dump on server</p>
    <div class="row g-3 align-items-end">

      <div class="col-md-4">
        <select [(ngModel)]="selectedDumpType" name="dumpType" class="form-select">
          <option value="">-- Select Database --</option>
          <option value="compass_stage">Compass</option>
          <option value="enemasterclass_with_testcenter">ENE-Masterclass</option>
          <option value="enhanceandexcel">Enhance & Excel</option>
          <option value="inodrive">Ino Drive</option>
          <option value="pptgen">PPT Gen</option>
          <option value="sidrive">SI Drive</option>
        </select>
      </div>

      <div class="col-md-auto">
        <button class="btn dash-btn info" (click)="generateDump()" [disabled]="isGenerating || !selectedDumpType">
          <i class="fas" [ngClass]="isGenerating ? 'fa-spinner fa-spin' : 'fa-database'"></i>
          {{ isGenerating ? 'Generating...' : 'Generate Dump' }}
        </button>
      </div>

    </div>

    <hr class="dump-divider" />

    <p class="dump-sub-label">Select a dump to download</p>
    <div class="row g-3 align-items-end">

      <div class="col-md-4">
        <select [(ngModel)]="selectedExistingDump" name="existingDump" class="form-select">
          <option value="">-- Select a Dump --</option>
          <option *ngFor="let dump of availableDumps" [value]="dump.value">
            {{ dump.key }}
          </option>
        </select>
      </div>

      <div class="col-md-auto">
        <button class="btn dash-btn success" (click)="downloadExistingDump()"
          [disabled]="isDownloading || !selectedExistingDump">
          <i class="fas" [ngClass]="isDownloading ? 'fa-spinner fa-spin' : 'fa-download'"></i>
          {{ isDownloading ? 'Downloading...' : 'Download Dump' }}
        </button>
      </div>

    </div>

  </div>
  <div class="admin-section-card mb-4">

    <h4 class="section-title">
      <i class="fas fa-user-plus"></i>
      Add User
    </h4>

    <form (ngSubmit)="addUser()">

      <div class="row g-3">

        <div class="col-md-2">
          <input type="text" [(ngModel)]="newUser.username" name="username" class="form-control" placeholder="Username"
            required />
        </div>

        <div class="col-md-2">
          <input type="text" [(ngModel)]="newUser.loginId" name="loginId" class="form-control" placeholder="Login ID"
            required />
        </div>

        <div class="col-md-2">
          <input type="password" [(ngModel)]="newUser.password" name="password" class="form-control"
            placeholder="Password" required />
        </div>

        <div class="col-md-2">
          <select [(ngModel)]="newUser.userType" name="userType" class="form-select" required>
            <option value="">User Type</option>
            <option value="admin">Admin</option>
            <option value="faculty">Faculty</option>
            <option value="player">Player</option>
          </select>
        </div>

        <div class="col-md-2">
          <select [(ngModel)]="newUser.userBatch" name="userBatch" class="form-select">
            <option value="">Select Batch</option>
            <option *ngFor="let b of batches" [value]="b.SDBatchId">
              {{ b.BatchName }}
            </option>
          </select>
        </div>

        <div class="col-md-2 d-grid">
          <button type="submit" class="btn dash-btn success">
            <i class="fas fa-check-circle"></i>
            Add User
          </button>
        </div>

      </div>
    </form>
  </div>


  <div class="admin-section-card">

    <h4 class="section-title">
      <i class="fas fa-users"></i>
      User Management
    </h4>

    <div class="table-responsive">
      <table class="table table-hover admin-table">

        <thead>
          <tr>
            <th>UserID</th>
            <th>Username</th>
            <th>LoginID</th>
            <th>User Type</th>
            <th>Status</th>
            <th>Batch</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let user of users">

            <td>{{ user.userId }}</td>
            <td>{{ user.username }}</td>
            <td>{{ user.loginid }}</td>
            <td>{{ user.userType }}</td>

            <td>
              <select [(ngModel)]="user.userStatus" class="form-select form-select-sm" (change)="updateUser(user)">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </td>

            <td>
              <select [(ngModel)]="user.userBatch" class="form-select form-select-sm" (change)="updateUser(user)">
                <option *ngFor="let b of batches" [value]="b.SDBatchId">
                  {{ b.BatchName }}
                </option>
              </select>
            </td>

            <td class="action-col">

              <button class="btn dash-btn primary" (click)="updateUser(user)">
                <i class="fas fa-floppy-disk"></i>
                Update
              </button>

              <button class="btn dash-btn warning" (click)="resetPassword(user)">
                <i class="fas fa-key"></i>
                Reset Password
              </button>

            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

</div> -->

<div class="admin-shell">

  <!-- ===== SIDEBAR ===== -->
  <aside class="admin-sidebar">

    <div class="sb-logo">
      <!-- <div class="sb-logo-title"><span>Admin</span> Dashboard</div> -->
      <img src="assets/logo.png" class="sidebar-logo mb-2" alt="SiDrive Logo">
      <div class="sb-logo-sub">{{ username }}</div>
      <!-- <h6 class="sb-logo-sub">{{ username }}</h6> User Name -->
    </div>

    <nav class="sb-nav">
      <div class="sb-section-label">Menu</div>

      <button class="sb-item" [class.active]="activePage === 'dump'" (click)="activePage = 'dump'">
        <i class="fas fa-database"></i>
        Download Dump
      </button>

      <button class="sb-item" [class.active]="activePage === 'users'" (click)="activePage = 'users'">
        <i class="fas fa-users"></i>
        User Management
      </button>
    </nav>

    <div class="sb-footer">
      <button class="sb-logout" (click)="onLogout()">
        <i class="fas fa-right-from-bracket"></i>
        Logout
      </button>
    </div>

  </aside>

  <!-- ===== MAIN ===== -->
  <div class="admin-main">

    <!-- Topbar -->
    <div class="admin-topbar">
      <div class="admin-page-title">
        <i class="fas" [ngClass]="activePage === 'dump' ? 'fa-database' : 'fa-users'"></i>
        {{ activePage === 'dump' ? 'Download Dump' : 'User Management' }}
      </div>
      <!-- <div class="topbar-right">Admin Portal</div> -->
    </div>

    <!-- Content -->
    <div class="admin-content">

      <!-- DUMP PAGE -->
      <ng-container *ngIf="activePage === 'dump'">
        <div class="admin-section-card mb-4">
          <h4 class="section-title">
            <i class="fas fa-database"></i> Generate Dump & Download
          </h4>
          <p class="dump-sub-label">Select a database and generate dump on server</p>
          <div class="row g-3 align-items-end">
            <div class="col-md-4">
              <select [(ngModel)]="selectedDumpType" name="dumpType" class="form-select">
                <option value="">-- Select Database --</option>
                <option value="compass_stage">Compass Stage</option>
                <option value="enemasterclass_with_testcenter">ENE-Masterclass</option>
                <option value="enhanceandexcel">Enhance &amp; Excel</option>
                <option value="inodrive">Ino Drive</option>
                <option value="pptgen">PPT Gen</option>
                <option value="sidrive">SI Drive</option>
              </select>
            </div>
            <div class="col-md-auto">
              <button class="btn dash-btn info" (click)="generateDump()" [disabled]="isGenerating || !selectedDumpType">
                <i class="fas" [ngClass]="isGenerating ? 'fa-spinner fa-spin' : 'fa-database'"></i>
                {{ isGenerating ? 'Generating...' : 'Generate Dump' }}
              </button>
            </div>
          </div>

          <hr class="dump-divider" />

          <p class="dump-sub-label">Select a dump to download</p>
          <div class="row g-3 align-items-end">
            <div class="col-md-4">
              <select [(ngModel)]="selectedExistingDump" name="existingDump" class="form-select">
                <option value="">-- Select a Dump --</option>
                <option *ngFor="let dump of availableDumps" [value]="dump.value">
                  {{ dump.key }}
                </option>
              </select>
            </div>
            <div class="col-md-auto">
              <button class="btn dash-btn success" (click)="downloadExistingDump()"
                [disabled]="isDownloading || !selectedExistingDump">
                <i class="fas" [ngClass]="isDownloading ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                {{ isDownloading ? 'Downloading...' : 'Download Dump' }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- USERS PAGE -->
      <ng-container *ngIf="activePage === 'users'">
        <div class="admin-section-card mb-4">
          <h4 class="section-title">
            <i class="fas fa-user-plus"></i> Add User
          </h4>
          <form (ngSubmit)="addUser()">
            <div class="row g-3">
              <div class="col-md-2">
                <input type="text" [(ngModel)]="newUser.username" name="username" class="form-control"
                  placeholder="Username" required />
              </div>
              <div class="col-md-2">
                <input type="text" [(ngModel)]="newUser.loginId" name="loginId" class="form-control"
                  placeholder="Login ID" required />
              </div>
              <div class="col-md-2">
                <input type="password" [(ngModel)]="newUser.password" name="password" class="form-control"
                  placeholder="Password" required />
              </div>
              <div class="col-md-2">
                <select [(ngModel)]="newUser.userType" name="userType" class="form-select" required>
                  <option value="">User Type</option>
                  <option value="admin">Admin</option>
                  <option value="faculty">Faculty</option>
                  <option value="player">Player</option>
                </select>
              </div>
              <div class="col-md-2">
                <select [(ngModel)]="newUser.userBatch" name="userBatch" class="form-select">
                  <option value="">Select Batch</option>
                  <option *ngFor="let b of batches" [value]="b.SDBatchId">{{ b.BatchName }}</option>
                </select>
              </div>
              <div class="col-md-2 d-grid">
                <button type="submit" class="btn dash-btn success">
                  <i class="fas fa-check-circle"></i> Add User
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="admin-section-card">
          <h4 class="section-title">
            <i class="fas fa-users"></i> User Management
          </h4>
          <div class="table-responsive">
            <table class="table table-hover admin-table">
              <thead>
                <tr>
                  <th>UserID</th>
                  <th>Username</th>
                  <th>LoginID</th>
                  <th>User Type</th>
                  <th>Status</th>
                  <th>Batch</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of users">
                  <td>{{ user.userId }}</td>
                  <td>{{ user.username }}</td>
                  <td>{{ user.loginid }}</td>
                  <td>{{ user.userType }}</td>
                  <td>
                    <select [(ngModel)]="user.userStatus" class="form-select form-select-sm"
                      (change)="updateUser(user)">
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </td>
                  <td>
                    <select [(ngModel)]="user.userBatch" class="form-select form-select-sm" (change)="updateUser(user)">
                      <option *ngFor="let b of batches" [value]="b.SDBatchId">{{ b.BatchName }}</option>
                    </select>
                  </td>
                  <td class="action-col">
                    <button class="btn dash-btn primary" (click)="updateUser(user)">
                      <i class="fas fa-floppy-disk"></i> Update
                    </button>
                    <button class="btn dash-btn warning" (click)="resetPassword(user)">
                      <i class="fas fa-key"></i> Reset Password
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>